import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from "./InputGroup";
import { ComponentProps, forwardRef, useState } from "react";

export interface InputPasswordProps extends Omit<ComponentProps<typeof InputGroupInput>, "type"> {}

const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <InputGroup className={className}>
        <InputGroupInput ref={ref} type={showPassword ? "text" : "password"} {...props} />
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            size="icon"
            onClick={() => setShowPassword(prev => !prev)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <IconEyeOff className="al-size-4" />
            ) : (
              <IconEye className="al-size-4" />
            )}
          </InputGroupButton>
        </InputGroupAddon>
      </InputGroup>
    );
  }
);

InputPassword.displayName = "InputPassword";

export { InputPassword };
